export enum AssetDragOperationState {
    NotDragging,
    FromAssetList,
    FromPortfolio,
}
